import type { MetaFunction } from "@remix-run/cloudflare";
import { Link } from "@remix-run/react";

import { Alert, AlertDescription } from "~/components/ui/alert";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "~/components/ui/card";

export const meta: MetaFunction = () => [{ title: "نسيت كلمة المرور" }];

export default function ForgotPage() {
  return (
    <main className="grid min-h-dvh place-items-center p-6 bg-paper-100">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>نسيت كلمة المرور</CardTitle>
          <CardDescription>
            استعادة كلمة المرور تتم من قبل مدير النظام مباشرةً
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert>
            <AlertDescription>
              راجع المسؤول لإعادة تعيين كلمة المرور لحسابك. لا يوجد إرسال بريد
              إلكتروني.
            </AlertDescription>
          </Alert>

          <div className="text-center text-xs">
            <Link to="/login" className="text-primary-600 hover:underline">
              العودة لتسجيل الدخول
            </Link>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
